import React from "react";
import {
  Box,
  ToggleButtonGroup,
  ToggleButton,
  InputAdornment,
} from "@mui/material";
import {
  CustomFormLabel,
  CustomTextField,
} from "../../../../../components/formsComponents";
import { formatCurrencyInIndian } from "../../../../../helpers/formatWithCommas";
import { useTheme, useMediaQuery } from "@mui/material";
interface DiscountFieldProps {
  value: string;
  mode: "percentage" | "amount";
  onModeChange: (mode: "percentage" | "amount") => void;
  onChange: (value: string) => void;
}

export const DiscountField = ({
  value,
  mode,
  onModeChange,
  onChange,
}: DiscountFieldProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let rawValue = e.target.value;

    if (mode === "amount") {
      // Remove all non-numeric characters for amount mode
      rawValue = rawValue.replace(/[^0-9]/g, "");
    } else {
      // For percentage, allow decimals
      rawValue = rawValue.replace(/[^0-9.]/g, "");
      // Prevent multiple decimal points
      const parts = rawValue.split(".");
      if (parts.length > 2) {
        rawValue = parts[0] + "." + parts.slice(1).join("");
      }
    }

    onChange(rawValue);
  };

  const displayValue =
    mode === "amount" && value ? formatCurrencyInIndian(value) : value || "";

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: isMobile ? 0.5 : 2,
        width: "100%",
      }}
    >
      <CustomFormLabel
        sx={{
          minWidth: isMobile ? "90px" : "130px",
          mb: 0,
        }}
      >
        Discount
      </CustomFormLabel>

      <ToggleButtonGroup
        value={mode}
        exclusive
        onChange={(e, val) => val && onModeChange(val)}
        size="small"
        sx={{
          height: "40px",
          flexShrink: 0,
          mr: isMobile ? 0.5 : 0,
          "& .MuiToggleButton-root": {
            px: isMobile ? 0.2 : 2,
            minWidth: isMobile ? "25px" : "48px",
          },
        }}
      >
        <ToggleButton value="percentage">%</ToggleButton>
        <ToggleButton value="amount">₹</ToggleButton>
      </ToggleButtonGroup>

      <CustomTextField
        fullWidth
        value={displayValue}
        onChange={handleInputChange}
        size="small"
        sx={{
          flex: 1,
        }}
        InputProps={{
          inputProps: {
            style: {
              textAlign: isMobile ? "left" : "right",
            },
          },
          startAdornment: isMobile ? (
            <InputAdornment position="start">
              {mode === "percentage" ? "%" : "₹"}
            </InputAdornment>
          ) : undefined,
          endAdornment: !isMobile ? (
            <InputAdornment position="end">
              {mode === "percentage" ? "%" : "₹"}
            </InputAdornment>
          ) : undefined,
        }}
      />
    </Box>
  );
};
